var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md3":"","xl3":""}},[_c('formAdminMonthlyCrossChargeFilter')],1),_c('v-flex',{attrs:{"md9":"","xl9":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }